import { Spinner, useLoading } from '@/components';
import { useAppContext } from '@/context';
import { useSearchParams } from 'react-router-dom';

export const N8nGenerator = () => {
  const { loading } = useLoading();
  const { sessionId } = useAppContext();
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab');
  const cid = searchParams.get('cid');

  // TODO: replace with real n8n iframe URL
  let url = `https://n8n-test.automation.palmapp.com/webhook/b0803e07-78ee-40c4-8c73-3745fc280551?sessionId=${sessionId}`;

  if (tab) {
    url += `&tab=${tab}`;
  }

  if (cid) {
    url += `&cid=${cid}`;
  }

  return loading ? (
    <Spinner fullSize={true} />
  ) : (
    <iframe
      src={url}
      style={{
        border: 'none',
        borderRadius: '6px',
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
      }}
    />
  );
};
